export const GAME_STATE_UPDATE_ENUM_ID = 130;
export const SOCKET_EVENT_ID = 137;
export const SOCKET_CLIENT_VERSION = '2';
/* eslint-enable colonist/camelcase-union-values */ export var ClientMessageSubType = /*#__PURE__*/ function(ClientMessageSubType) {
    ClientMessageSubType[ClientMessageSubType["GameAction"] = 1] = "GameAction";
    ClientMessageSubType[ClientMessageSubType["LobbyAction"] = 2] = "LobbyAction";
    ClientMessageSubType[ClientMessageSubType["RoomAction"] = 3] = "RoomAction";
    ClientMessageSubType[ClientMessageSubType["MatchmakingAction"] = 4] = "MatchmakingAction";
    ClientMessageSubType[ClientMessageSubType["ChannelAction"] = 5] = "ChannelAction";
    ClientMessageSubType[ClientMessageSubType["Noop"] = 6] = "Noop";
    ClientMessageSubType[ClientMessageSubType["GeneralAction"] = 7] = "GeneralAction";
    ClientMessageSubType[ClientMessageSubType["Echo"] = 8] = "Echo";
    ClientMessageSubType[ClientMessageSubType["CloseSocket"] = 9] = "CloseSocket";
    ClientMessageSubType[ClientMessageSubType["RoomCommand"] = 10] = "RoomCommand";
    ClientMessageSubType[ClientMessageSubType["ShuffleAction"] = 11] = "ShuffleAction";
    return ClientMessageSubType;
}({});
/* https://tools.ietf.org/html/rfc6455 */ export const SOCKET_CLOSE_GOING_AWAY = 1001;
export const SOCKET_CLOSE_SERVER_RESTARTING = 1012;
// custom codes have to be between 4000 and 4255
export const SOCKET_CLOSE_FROM_ROOM = 4000;
export const SOCKET_CLOSE_SESSION_ERROR = 4003;
export const SOCKET_CLOSE_NO_SESSION = 4004;
export const SOCKET_CLOSE_SESSION_NOT_YET_ESTABLISHED = 4005;
export const SOCKET_CLOSE_SESSION_NOT_RESPONDING = 4006;
export const SOCKET_CLOSE_KICKED = 4007;
export const SOCKET_CLOSE_USER_LOGOUT = 4009;
export const SOCKET_CLOSE_ROOM_STATE_SEQUENCE_ERROR = 4010;
export const SOCKET_CLOSE_GAME_CLIENT_ERROR = 4012;
export const SOCKET_CLOSE_RATE_LIMITED = 4014;
export const SOCKET_CLOSE_USER_CHANGED = 4015;
export const SOCKET_CLOSE_PING_TIMEOUT = 4016;
export const SOCKET_CLOSE_SERVER_TOO_SLOW = 4017;
export const SOCKET_CLOSE_MISSING_AUTH = 4018;
export const SOCKET_CLOSE_REQUIRE_TURNSTILE_TOKEN = 4019;
